function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  rx: 9,
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.74848 5.59755C6.74848 6.06966 6.37856 6.44974 5.75918 6.44974C5.1742 6.44974 4.79999 6.06966 4.79999 5.59755C4.79999 5.11344 5.1828 4.74536 5.78068 4.74536C6.37856 4.74536 6.73987 5.11344 6.74848 5.59755ZM4.8516 7.1259H6.68826V12.6271H4.8516V7.1259ZM7.78939 8.88229C7.78939 8.19413 7.76358 7.62201 7.73777 7.1259H9.33356L9.41958 7.89407H9.45399C9.69486 7.53399 10.2927 7.00587 11.282 7.00587C12.4864 7.00587 13.3983 7.76204 13.3983 9.3784V12.6271H11.5573V9.57844C11.5573 8.86629 11.2949 8.38618 10.6282 8.38618C10.1207 8.38618 9.8153 8.71025 9.68626 9.02232C9.63465 9.13835 9.62604 9.29838 9.62604 9.45042V12.6231H7.78939V8.88229Z",
  fill: "white"
});
function SvgLinkedinCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinCircle);
export default __webpack_public_path__ + "static/media/linkedin-circle.084758e5.svg";
export { ForwardRef as ReactComponent };